export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del contenedor"])},
          "title_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "title_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets"])},
          "title_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "title_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjuntos"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aún no tiene exportación asignada"])},
          "download_packing_list_producer_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar packing list por productor"])},
          "download_packing_list_pallet_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar packing list por pallet"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container data"])},
          "title_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "title_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets"])},
          "title_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "title_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachments"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to the list of containers"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have not yet assigned an export"])},
          "download_packing_list_producer_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download packing list by producer"])},
          "download_packing_list_pallet_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download packing list by pallet"])}
        }
      }
    }
  })
}